import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { useAuth } from '../contexts/AuthContext';
import { ApiError, classesApi, type SchoolClass } from '../services/api/client';

const LEVEL_LABEL = {
  UNDERGRADUATE: 'Graduação',
  GRADUATE: 'Pós-graduação',
} as const;

export default function ClassesPage() {
  const { user } = useAuth();
  const isProfessor = user?.role === 'PROFESSOR';

  const [classes, setClasses] = useState<SchoolClass[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    classesApi
      .list()
      .then((result) => setClasses(result.classes))
      .catch((err: unknown) =>
        setError(err instanceof ApiError ? err.message : 'Falha ao carregar as turmas.'),
      );
  }, []);

  return (
    <>
      <div className="section-head">
        <h2>Turmas</h2>
        {isProfessor && (
          <Link to="/turmas/nova" className="button-link">
            Nova turma
          </Link>
        )}
      </div>

      {error && <p className="form-error">{error}</p>}
      {!classes && !error && <p className="muted">Carregando…</p>}

      {classes?.length === 0 && (
        <section className="card empty-state">
          {isProfessor ? (
            <>
              <p>Você ainda não criou nenhuma turma.</p>
              <Link to="/turmas/nova" className="button-link">
                Criar a primeira turma
              </Link>
            </>
          ) : (
            <p>
              Você ainda não está em nenhuma turma. Use o QR Code ou o link que o
              professor compartilhar.
            </p>
          )}
        </section>
      )}

      <div className="class-grid">
        {classes?.map((item) => (
          <Link key={item.id} to={`/turmas/${item.id}`} className="card class-card">
            <div className="class-card-head">
              <h3>{item.name}</h3>
              {item.status === 'ARCHIVED' && <span className="badge">Arquivada</span>}
            </div>

            <p className="muted">{item.discipline}</p>

            <dl className="class-meta">
              <div>
                <dt>Curso</dt>
                <dd>{item.course}</dd>
              </div>
              <div>
                <dt>Nível</dt>
                <dd>{LEVEL_LABEL[item.level]}</dd>
              </div>
              <div>
                <dt>Período letivo</dt>
                <dd>{item.academicTerm}</dd>
              </div>
            </dl>

            {isProfessor && item._count && (
              <p className="class-counts">
                {item._count.members} aluno{item._count.members === 1 ? '' : 's'} ·{' '}
                {item._count.groups} grupo{item._count.groups === 1 ? '' : 's'}
              </p>
            )}

            {!isProfessor && item.professorName && (
              <p className="class-counts">Prof. {item.professorName}</p>
            )}
          </Link>
        ))}
      </div>
    </>
  );
}
